import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import * as React from 'react';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';

interface IProps {
  openModal: boolean;
  closeModal: () => void;
  title: React.ReactElement<any> | string;
  content: React.ReactElement<any> | string;
}

const RequirePermissionWizard: React.FC<IProps> = ({ openModal, closeModal, title, content }) => (
  <Dialog width={500} title={title} open={openModal} onClose={closeModal} id="receipt-wizard">
    <div className="font-bold text-sm mt-1">{content}</div>
    <DialogActionsBar>
      <div className="flex justify-end">
        <Button color="info" onClick={closeModal}>
          OK
        </Button>
      </div>
    </DialogActionsBar>
  </Dialog>
);
export default RequirePermissionWizard;
